import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.75 17.5V7C6.75 6.30964 7.30964 5.75 8 5.75C8.69036 5.75 9.25 6.30964 9.25 7V17.5C9.25 18.1904 8.69036 18.75 8 18.75C7.30964 18.75 6.75 18.1904 6.75 17.5ZM14.75 17.5V7C14.75 6.30964 15.3096 5.75 16 5.75C16.6904 5.75 17.25 6.30964 17.25 7V17.5C17.25 18.1904 16.6904 18.75 16 18.75C15.3096 18.75 14.75 18.1904 14.75 17.5Z",
		fill: "#333333"
	})
});
export default SvgPause;
